import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import { Button, Input } from "@wac-ui-dashboard/wac_component_library";
import useCurbSide from "./useCurbSide";
import Style from "../addStore.module.scss";
const CurbSide = ({ formik, getFieldError, storeState, setStoreState }) => {
  const {
    time,
    handleCloseModal,
    handleTimeChange,
    daysOfWeek,
    handleToggle,
    handleNext,
    enabledDays,
  } = useCurbSide({ formik, storeState, setStoreState });

  return (
    <>
      <div className="form-check form-switch pro-mb-4">
        <input
          className="form-check-input cursor-pointer"
          type="checkbox"
          role="switch"
          id="curb_side"
          name="curb_side"
          checked={Boolean(formik.values?.curb_side === 1) ?? false}
          onChange={(e) => {
            formik.setFieldValue("curb_side", e.target.checked ? 1 : 2);
          }}
        />
        <label htmlFor="curb_side" className="pro-check-label">
          Set Curb Hours
        </label>
        {getFieldError("curb_side") && (
          <div className={`${Style.form_toggle_err_msg}`}>
            {getFieldError("curb_side") ||
              "Please select at least one day's hours."}
          </div>
        )}
      </div>

      {formik.values?.curb_side === 1 && (
        <>
          {daysOfWeek.map((day) => (
            <div
              key={day}
              className={`pro-d-flex pro-flex-column pro-mb-4 ${Style.time_wrap}`}
            >
              <label className="pro-font-sm pro-mb-1 pro-fw-medium">
                {day}
              </label>
              <div
                className={`pro-d-flex pro-items-center ${Style.time_picker_wrap}`}
              >
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <TimePicker
                    value={time[day]?.from || ""}
                    onChange={(newValue) =>
                      handleTimeChange(day, "from", newValue)
                    }
                    className="time-picker"
                    disabled={
                      !enabledDays[day] || formik.values.curb_side === 0
                    }
                  />

                  <span className="pro-px-3 pro-d-flex pro-items-center">
                    <span className="material-symbols-outlined x4">
                      {" "}
                      remove{" "}
                    </span>
                  </span>

                  <TimePicker
                    value={time[day]?.to || ""}
                    onChange={(newValue) =>
                      handleTimeChange(day, "to", newValue)
                    }
                    className="time-picker"
                    // minTime={getMinToTime(day, time[day]?.from)}
                    disabled={
                      !enabledDays[day] || formik.values.curb_side === 0
                    }
                  />
                  <div className="form-check form-switch pro-mb-0 pro-ms-auto">
                    <input
                      className="form-check-input cursor-pointer"
                      type="checkbox"
                      role="switch"
                      id={`${day}-switch`}
                      checked={enabledDays[day] || false}
                      onChange={() => handleToggle(day)}
                    />
                  </div>
                </LocalizationProvider>
              </div>
              {/* {curbTimeError[day] !== null && (
                <span className="error pro-mt-2 pro-font-xs pro-lh-1">
                  {curbTimeError[day]}
                </span>
              )} */}
            </div>
          ))}
        </>
      )}
      <div className={`col-12 pro-d-flex pro-justify-end pro-pb-5 pro-mt-auto`}>
        <Button
          className={"pro-btn-link lg pro-px-5"}
          onClick={handleCloseModal}
          type="button"
        >
          Cancel
        </Button>
        <Button
          className={"pro-btn-primary lg pro-ms-3"}
          onClick={handleNext}
        >
          {"Next"}
        </Button>
      </div>
    </>
  );
};

export default CurbSide;
